<dx-data-grid
  [dataSource]="applicationLinkEndpointInformation"
  [showBorders]="true"
  [columnAutoWidth]="true"
>
  <dxi-column dataField="name" dataType="string"></dxi-column>
  <dxi-column dataField="url" dataType="date"></dxi-column>
  <dxi-column dataField="kind" cellTemplate="kindCellTemplate" caption="Endpoint type"></dxi-column>

  <div class="icon-cell" *dxTemplate="let d of 'kindCellTemplate'">
	  {{getKindName(d.value)}}
  </div>


</dx-data-grid>
